export const DATE_FORMAT = "dd.MM.yyyy";
export const DATE_PLACEHOLDER = "dd.mm.yyyy";
export const ACCEPT_DATE_FORMATS = ["dd.MM.yyyy", "dd/MM/yyyy", "dd-MM-yyyy", "ddMMyyyy"];
export const ContentDatePicker = {
    DefaultMinDate: new Date(2000, 1, 1),
    CannotBeEmpty: "Can't be empty",
    CannotBeInThePast: "Date cannot be in the past",
    CannotBeInTheFuture: "Date cannot be in the future",
    Today: "Today",
    DateFormat: "dd/MM/yyyy",
};
